// Directus's built-in per-user notifications inbox (directus_notifications).
// Read-only: "seen" is tracked on this device, so nothing is written back.

import { readNotifications } from "@directus/sdk";
import { IS_PREVIEW } from "../config";
import directus from "./directusClient";
import { readJson, writeJson } from "./storage";

export const NOTIFICATION_FIELDS = ["id", "subject", "message", "timestamp"];

const text = (value) =>
  typeof value === "string" && value.trim() ? value.trim() : null;

const mapNotification = (raw) => ({
  id: raw.id,
  subject: text(raw.subject) || "Notification",
  message: text(raw.message),
  receivedAt: raw.timestamp || null,
});

export const listNotifications = async () => {
  if (IS_PREVIEW) return [];
  const rows = await directus.request(
    readNotifications({
      fields: NOTIFICATION_FIELDS,
      filter: {
        recipient: { _eq: "$CURRENT_USER" },
        status: { _eq: "inbox" },
      },
      sort: ["-timestamp"],
      limit: 20,
    })
  );
  return rows.map(mapNotification);
};

const time = (iso) => {
  const parsed = Date.parse(iso);
  return Number.isNaN(parsed) ? 0 : parsed;
};

export const isNewSince = (notification, lastSeen) =>
  time(notification.receivedAt) > time(lastSeen);

export const countUnseen = (items, lastSeen) =>
  items.filter((item) => isNewSince(item, lastSeen)).length;

export const newestTimestamp = (items) =>
  items.reduce(
    (newest, item) => (isNewSince(item, newest) ? item.receivedAt : newest),
    null
  );

const seenKey = (userId) => `notifications-seen:${userId}`;

export const getLastSeen = (userId) => readJson(seenKey(userId), null);

export const setLastSeen = (userId, timestamp) =>
  writeJson(seenKey(userId), timestamp);
